import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-center mt-4" }

import CollapsibleItem from "@/layout/collapsible/CollapsibleItem.vue";
import schemaConfermate from "@/../../EshJSLib/models/form/diagnosiconfermate.json";
import schemaEscluse from "@/../../EshJSLib/models/form/diagnosiescluse.json";
import schemaSospette from "@/../../EshJSLib/models/form/diagnosisospete.json";
import { storeToRefs } from "pinia";
import { patientStore } from "@/store/patient";
import ModalDeleteDiagnosi from "@/views/Diagnosi/modal_delete.vue";
import ModalConfidenzialita from "@/views/Diagnosi/modal_confidenzialita.vue";
import ModalSposta from "@/views/Diagnosi/modal_sposta.vue";
import ModalEdit from "@/views/Diagnosi/modal_edit.vue";
import ModalAdd from "@/views/Diagnosi/modal_add.vue";

import { Diagnosi, DiagnosiClass, DiagnosiDetails } from "@/../../EshJSLib/models/patient";
import { deletePatient } from "@/../../EshJSLib/services/diagnosiServices";
import { Vue } from "vue-class-component";

import { onMounted, ref, reactive } from "vue";
import { useRouter } from "vue-router";
import { Modal } from "flowbite-vue";
import { hasPermission } from "../../../../EshJSLib/services/securityServices";


export default /*#__PURE__*/_defineComponent({
  __name: 'DiagnosiPage',
  setup(__props) {

const store = patientStore();
const { patient } = storeToRefs(store);
const router = useRouter();
const isShownModal = reactive({
    alert: false,
    movePage: false,
    confirm: false,
    alertMove: false,
});

function movePage() {
    router.push({ path: 'Paypal' })
}

onMounted(async () => {
    store.fetchDiagnosi();

});


const modalDeleteDiagnosi = ref<InstanceType<typeof ModalDeleteDiagnosi> | null>(null);
const modalConfidenzialita = ref<InstanceType<typeof ModalConfidenzialita> | null>(null);
const modalSposta = ref<InstanceType<typeof ModalSposta> | null>(null);
const modalEditDiagnosi = ref<InstanceType<typeof ModalEdit> | null>(null);
const modalAddDiagnosi = ref<InstanceType<typeof ModalAdd> | null>(null);

async function action(type: string, row: DiagnosiClass, newRow: Diagnosi, stato: string) {
    let userInput;
    switch (type) {
        case "arrow-down":
            if (await hasPermission('spostaDiagnosi')) {
                userInput = await modalSposta.value?.openModal(null, true, row as unknown as Diagnosi);
                if (userInput) {
                    store.savePaziente("diagnosi", row.id_diagnosi).then((x) => {
                        store.fetchDiagnosi();
                    });
                } else {
                    store.fetchDiagnosi();
                }
            } else {
                isShownModal.alert = true;
            }
            break;


        case "trash":
            userInput = await modalDeleteDiagnosi.value?.openModal(null, true, row as unknown as Diagnosi);
            if (userInput) {
                deletePatient(row.id_diagnosi).then(x => {
                    store.fetchDiagnosi();
                });
            }
            break;

        case "pen":
            if (await hasPermission('modificadiagnosi')) {
                userInput = await modalEditDiagnosi.value?.openModal("Modifica file", true, row as unknown as Diagnosi);
                if (userInput) {
                    store.savePaziente("diagnosi", row.id_diagnosi).then((x) => {
                        store.fetchDiagnosi();
                    });
                } else {
                    store.fetchDiagnosi();
                }
            } else {
                isShownModal.alert = true;
            }
        break;

        case "lock":
            userInput = await modalConfidenzialita.value?.openModal(null, true, row as unknown as Diagnosi);
            if (userInput) {
                store.savePaziente("diagnosi", row.id_diagnosi).then((x) => {
                    store.fetchDiagnosi();
                });
            }
            break;

        case "newRecord":
            var id_tipo_licenza = patient.value.sottoscrizione.id_tipo_licenza
            if (await hasPermission('aggiungidiagnosi')) {
                newRow = {} as Diagnosi;
                newRow.id_diagnosi = 0;
                newRow.id_paziente = patient.value.id_paziente;
                newRow.diagnosi_stato = stato;
                newRow.id_livello_confidenzialita = 6
                newRow.diagnosiDetails = {} as DiagnosiDetails
                userInput = await modalAddDiagnosi.value?.openModal(null, true, newRow);
                if (userInput) {
                    patient.value.diagnosi.push(newRow);
                    console.log(newRow);
                    store.savePaziente("diagnosi", newRow.id_diagnosi).then((x) => {
                        store.fetchDiagnosi();
                    });
                }
            } else {
                isShownModal.alert = true;
            }
            break;
        default:
            break;
    }
}




return (_ctx: any,_cache: any) => {
  return (_unref(patient))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(ModalDeleteDiagnosi, {
          ref_key: "modalDeleteDiagnosi",
          ref: modalDeleteDiagnosi
        }, null, 512),
        _createVNode(ModalConfidenzialita, {
          ref_key: "modalConfidenzialita",
          ref: modalConfidenzialita
        }, null, 512),
        _createVNode(ModalSposta, {
          ref_key: "modalSposta",
          ref: modalSposta
        }, null, 512),
        _createVNode(ModalEdit, {
          ref_key: "modalEditDiagnosi",
          ref: modalEditDiagnosi
        }, null, 512),
        _createVNode(ModalAdd, {
          ref_key: "modalAddDiagnosi",
          ref: modalAddDiagnosi
        }, null, 512),
        (isShownModal.alert)
          ? (_openBlock(), _createBlock(_unref(Modal), {
              key: 0,
              onClose: _cache[2] || (_cache[2] = ($event: any) => (isShownModal.alert = false))
            }, {
              body: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("Questa sezione non è prevista nella tua sottoscrizione")), 1),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (isShownModal.alert = false)),
                    type: "button",
                    class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
                  }, _toDisplayString(_ctx.$t("Annulla")), 1),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (movePage())),
                    type: "button",
                    class: "text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
                  }, _toDisplayString(_ctx.$t("Iscriviti")), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(CollapsibleItem, {
          id: "confermateCollaps",
          data: _unref(schemaConfermate),
          onRowActions: _cache[3] || (_cache[3] = (n, r, i) => action(n, r, i, 'confermate')),
          onCreateForm: _cache[4] || (_cache[4] = ($event: any) => (action('newRecord', null, null, '0')))
        }, null, 8, ["data"]),
        _createVNode(CollapsibleItem, {
          id: "sospetteCollaps",
          data: _unref(schemaSospette),
          onRowActions: _cache[5] || (_cache[5] = (n, r, i) => action(n, r, i, 'sospette')),
          onCreateForm: _cache[6] || (_cache[6] = ($event: any) => (action('newRecord', null, null, '1')))
        }, null, 8, ["data"]),
        _createVNode(CollapsibleItem, {
          id: "escluseCollaps",
          data: _unref(schemaEscluse),
          onRowActions: _cache[7] || (_cache[7] = (n, r, i) => action(n, r, i, 'ecluse')),
          onCreateForm: _cache[8] || (_cache[8] = ($event: any) => (action('newRecord', null, null, '2')))
        }, null, 8, ["data"])
      ]))
    : _createCommentVNode("", true)
}
}

})